import React from 'react';
import moment from 'moment';
import { copyTextToClipboard, getLocalTime, handleFeedback } from '../../../utils/helpers';
import { Button, Icon } from '../../../subkit-ui';
import Schedule from '../../../containers/ProviderService/Schedule.container';
import TWSessionInfo from '../../SessionLandingPage/TWSessionInfo/SessionInfo.container';
import TWSessionBookingOptionsContainer from '../TWSessionBookingOptions/TWSessionBookingOptions.container';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var TWSessionView = function TWSessionView(_ref) {
  var _session$providerServ, _session$providerServ2;

  var session = _ref.session,
      schedule = _ref.schedule,
      profilePath = _ref.profilePath;

  var _getLocalTime = getLocalTime(moment(session.startsAt)),
      localSessionStart = _getLocalTime.localTime;

  var sessionTime = "".concat(localSessionStart.format('dddd, MMMM DD'), " at ").concat(localSessionStart.format('h:mm A z'));

  var handleSessionShare = function handleSessionShare(event) {
    event.preventDefault();
    copyTextToClipboard(window.location.href) && handleFeedback(null, 'Session link copied to clipboard');
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: session && session.providerService && /*#__PURE__*/_jsxs("div", {
      className: "p-4",
      children: [/*#__PURE__*/_jsxs("a", {
        href: profilePath,
        className: "flex text-neutral-500 text-base font-medium no-underline mb-2",
        children: [/*#__PURE__*/_jsx(Icon, {
          name: "angle-left",
          type: "regular",
          className: "text-xl"
        }), /*#__PURE__*/_jsxs("span", {
          className: "block ml-2 text-base",
          children: ["Back to ", session === null || session === void 0 ? void 0 : (_session$providerServ = session.providerService) === null || _session$providerServ === void 0 ? void 0 : _session$providerServ.name]
        })]
      }), /*#__PURE__*/_jsx("h1", {
        className: "m-0",
        children: session.name
      }), /*#__PURE__*/_jsx("p", {
        className: "text-lg text-neutral-500 m-0",
        children: sessionTime
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-5",
        children: /*#__PURE__*/_jsx(Button, {
          icon: "share",
          iconType: "solid",
          text: "Share",
          type: "secondary",
          onClick: handleSessionShare
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "md:flex my-4",
        children: [/*#__PURE__*/_jsx("div", {
          className: "block w-full md:w-7/12 md:pl-0 md:pr-32",
          children: /*#__PURE__*/_jsx(TWSessionInfo, {
            session: session,
            renderHeading: false,
            renderProvider: false
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "block w-full md:w-5/12",
          children: /*#__PURE__*/_jsx(TWSessionBookingOptionsContainer, {
            session: session
          })
        })]
      }), (schedule === null || schedule === void 0 ? void 0 : schedule.length) > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: "text-center text-neutral-900 text-xl mt-20 mb-4",
          children: ["Other sessions from ", session === null || session === void 0 ? void 0 : (_session$providerServ2 = session.providerService) === null || _session$providerServ2 === void 0 ? void 0 : _session$providerServ2.name]
        }), /*#__PURE__*/_jsx(Schedule, {
          providerService: session === null || session === void 0 ? void 0 : session.providerService,
          showTitle: false,
          cardShadow: true,
          excludeSession: session.id,
          classes: "w-full"
        })]
      })]
    })
  });
};